import type {
	ActivityTab,
	QueryTab,
	SidePanelAction,
	SidePanelControllerState,
	TabHistory,
} from '@atlassian/audit-logs-common';

/**
 * Pure reducer for side panel state management with tab history persistence.
 * Maintains the last selected tab for each mode, so switching between modes
 * restores the previously selected tab.
 */
export function sidePanelReducer(
	panel: SidePanelControllerState,
	action: SidePanelAction,
): SidePanelControllerState {
	switch (action.type) {
		case 'SET_TAB': {
			if (!panel) {
				return panel;
			}

			// Update active tab and save to history
			const updatedTabHistory: TabHistory = {
				...panel.tabHistory,
				[panel.mode]: action.tab as any,
			};

			if (panel.mode === 'activity-details') {
				return {
					...panel,
					activeTab: action.tab as ActivityTab,
					tabHistory: updatedTabHistory,
				};
			}

			// panel.mode === 'query-details'
			return {
				...panel,
				activeTab: action.tab as QueryTab,
				tabHistory: updatedTabHistory,
			};
		}

		case 'SWITCH_MODE': {
			if (!panel) {
				return panel;
			}

			// Don't switch if already in that mode
			if (panel.mode === action.mode) {
				return panel;
			}

			// Mode switching is handled in the component since it changes
			// the entire state structure. This is here for completeness.
			return panel;
		}

		case 'CLOSE':
			// Closing the panel sets state to null
			return null;

		default:
			return panel;
	}
}
